import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/download.svg';

export const IconDownload = createIconComponent(Icon);
